import React from "react";
import { string, number } from "prop-types";
import { connect } from "react-redux";

import { staticTexts } from "../../utils/Translate";

import "./bigNumber.m.css";

const BigNumber = ({ lang, headlineNumber, numberStyle = "number", className = "" }) => {
  return (
    <span styleName="number" className={className}>
      {numberStyle === "bullet" ? <div styleName="bullet"></div> : staticTexts(lang).NUMBER_ARRAY[headlineNumber]}
    </span>
  );
};

BigNumber.propTypes = {
  lang: string,
  numberStyle: string,
  headlineNumber: number,
  className: string,
};

const mapStateToProps = (state) => ({
  lang: state.qt.config["publisher-attributes"].lang || "bn",
});

export default connect(mapStateToProps)(BigNumber);
